// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"470ac86a","667":"a60b6596","977":"76786786"}[chunkId] + ".chunk.js";
};